/*global PayFacto*/
import React, { useEffect, useState } from "react";
import { callAPI } from "../../utils";

export default function TSYS(props) {
  const secureID = props.secureID;
  const sessionId = props.tranId;
  const showAddress = props.zipcodeEnable;
  const alert = props.alert;
  const setIsLoading = props.setIsLoading;
  const [isScreenSuccess, setIsScreenSuccess] = useState(false);

  useEffect(() => {
    async function fetchData() {
      if (!PayFacto.initialized) {
        if (!secureID) {
          alert("Please provide secureID!");
          return;
        }
        if (!sessionId) {
          alert("Please provide sessionId!");
          return;
        }
        const debug = process.env.REACT_APP_PAYFACTO_API_URL.includes("test");
        console.log("Debug mode", debug);
        PayFacto.setGlobalConfiguration({
          apiUrl: process.env.REACT_APP_PAYFACTO_API_URL,
          iframeUrl: process.env.REACT_APP_PAYFACTO_IFRAME_URL,
          debug: debug,
        });
        await PayFacto.init(secureID, {}).then(function (c, d) {
          console.log(c, d);
          PayFacto.modal(
            function (tokenPromise) {
              setIsLoading(true);
              tokenPromise
                .then(async function (token) {
                  console.log(token);
                  if (token.returnCode === "00" && token.token) {
                    const response = await callAPI(
                      `${process.env.REACT_APP_WEBHOOK_API_ENDPOINT}/api/webhook/notification/TSYS`,
                      "GET",
                      null,
                      {
                        sessionId,
                        token: token.token,
                      }
                    );
                    console.log(response);
                    if (response.data.data.returnCode !== 200) {
                      setIsLoading(false);
                      alert(
                        `Processing error code: ${response.data.data.returnCode}`
                      );
                      // Pass response data back to parent component
                      if (props.onFailure) {
                        props.onFailure(response.data.data);
                      }
                    } else {
                      setIsLoading(false);
                      setIsScreenSuccess(true);
                      // Pass response data back to parent component
                      if (props.onSuccess) {
                        props.onSuccess(response.data.data);
                      }
                    }
                  } else {
                    alert(`Processing error code:${token.returnCode}`);
                  }
                })
                .catch(function (error) {
                  console.error(error);
                  setIsLoading(false);
                  alert(
                    `${error.errorDescription}. Code: ${error.returnCode}`
                  );
                });
            },
            {
              id: "payfacto-secure-fields-modal",
              classes: "custom-1",
              permanent: true,
              header: {
                title: "Gojo",
                subtitle: "You can easily override anything!",
              },
              buttons: {
                submit: {
                  text: "XXX!",
                },
              },
              sections: {
                credit: {
                  cvv: true,
                },
                address: {
                  address: showAddress === "true",
                  "postal-code": true,
                },
              },
              fields: {
                all: {
                  title: {
                    floating: false,
                  },
                },
                "card-number": {
                  mask: {
                    placeholder: "Some custom placeholder...",
                  },
                },
              },
            }
          );
        });
      }
    }
    fetchData();
  }, [alert, secureID, sessionId, setIsLoading, showAddress, props]);

  return (
    <div className="App">
      <div id="payfacto-secure-fields-modal" />
      {isScreenSuccess && (
        <div id="screenSuccess">
          <div>
            <p> Card has been added successfully </p>
          </div>
        </div>
      )}
    </div>
  );
}
